import React from "react";

export interface VitalsMetricCardProps {
  title: string;
  value: string | number;
  unit: string;
  periodLabel: string;
  /** @deprecated – colors are now semantic; this prop is ignored */
  iconColorClass?: string;
  /** @deprecated – border hover is now semantic; this prop is ignored */
  borderColorClass?: string;
  onClick: () => void;
  /** @deprecated – theming handled via ThemeProvider; this prop is ignored */
  darkMode?: boolean;
}

export const VitalsMetricCard = ({
  title,
  value,
  unit,
  periodLabel,
  onClick,
}: VitalsMetricCardProps) => (
  <div
    onClick={onClick}
    className="flex flex-col p-3 rounded-xl cursor-pointer transition-all bg-muted/40 border border-border/60 hover:bg-muted/60 hover:border-border hover:shadow-sm"
  >
    <p className="z-eyebrow text-muted-foreground truncate mb-2" title={title}>
      {title}
    </p>

    <div className="flex items-baseline gap-1 mb-2 flex-wrap">
      <p className="z-h3 z-numeric text-foreground break-words">{value}</p>
      <span className="z-caption text-muted-foreground shrink-0">{unit}</span>
    </div>

    <div className="mt-auto pt-2 border-t border-border/60">
      <p className="z-hint text-muted-foreground truncate">{periodLabel}</p>
    </div>
  </div>
);
